<template lang="html">
  <div>
    <div id="video" class="video-carousel carousel">
      <template v-if="videoLink">
        <div class="videoLink">
          <a :href="videoLink" target="_blank">{{ $tr('responses.goToVideo') }}</a>
        </div>
      </template>
    </div>
  </div>
</template>

<style>
  .carousel {
    margin-right: 10px;
  }
</style>

<script>
  import VideoPlayer from '@/components/VideoPlayer.vue'

  import MixinState from '../../../mixins/state.js'

  export default {
    name: 'process-response-videointerview-scene',

    components: {
      VideoPlayer
    },

    mixins: [
      MixinState
    ],

    computed: {
      // storeResponseDataBatChampionship lives in mixin
      videoLink () {
        return this.storeResponseDataBatChampionship ? this.storeResponseDataBatChampionship.video_link : null
      },

      // storeResponseDataBatChampionship lives in mixin
      isYoutube () {
        return this.storeResponseDataBatChampionship ? Boolean(this.storeResponseDataBatChampionship.is_youtube) : false
      }
    }
  }
</script>

<style scoped>
  #video {
    padding-top: 10px;
  }

  .videoLink {
      font-size: 1.5em;
    }
</style>
